
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/perfil/externo/[root]/[...slug]",
      function () {
        return require("private-next-pages/perfil/externo/[root]/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/perfil/externo/[root]/[...slug]"])
      });
    }
  